export default __webpack_public_path__ + "static/media/il.a14cb2d2.svg";